import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { Col, Container, Row, Button } from 'react-bootstrap'
import { excerpt } from '../../utils/helper'
import Footer from '../global/Footer'
import Header from '../global/Header'
import classes from './Category.module.css'
import { FaBars } from 'react-icons/fa'
import { BsFillGridFill } from 'react-icons/bs'
import { Link, useParams } from 'react-router-dom'
import Loader from '../global/Loader'
import { baseUrl } from '../../consts/consts'
import ComingSoonComponent from '../global/ComingSoonComponent'
import SomethingWentWrongComponent from '../global/SomethingWentWrongComponent'

const Category = () => {
  const [grid, setGrid] = useState(false)
  const [loader, setLoader] = useState(false)
  const [comingSoon, setComingSoon] = useState(false)
  const [error, setError] = useState(false)
  const [categories, setCategories] = useState([])
  const { category: categorySlug } = useParams()

  useEffect(() => {
    getCategories()
  }, [])

  const getCategories = async () => {
    try {
      setLoader(true)
      const { data } = await axios.get(
        `${baseUrl}/product-categories/${categorySlug}`
      )
      console.log(data.data.product)
      if (data && data.data && data.data.product.length) {
        setCategories(data.data.product)
      } else {
        setComingSoon(true)
      }
      setLoader(false)
    } catch (error) {
      setError(true)
      setLoader(false)
    }
  }

  const layoutHandler = () => {
    setGrid((prevState) => !prevState)
  }

  return (
    <>
      <div className={!comingSoon && 'bodys1'}>
        {loader && <Loader />}
        {!loader && (
          <>
            <Header />
            {error && <SomethingWentWrongComponent />}
            {comingSoon && !error && <ComingSoonComponent />}
            {!comingSoon && !error && (
              <div className='overlay1'>
                <Container>
                  <div className={classes.iconContainer}>
                    <div className={classes.icon} onClick={layoutHandler}>
                      {grid ? <FaBars /> : <BsFillGridFill />}
                    </div>
                  </div>
                  <Row>
                    {categories &&
                      categories.map((category) => (
                        <Col md={grid ? 4 : 12} key={category.slug}>
                          <div
                            className={`${classes.cardContainer} ${
                              !grid && classes.flexContainer
                            }`}
                          >
                            <Link
                              to={`/category/${categorySlug}/${category.slug}`}
                              className={classes.link}
                            >
                              <div
                                className={`${classes.imageContainer} ${
                                  grid && classes.gridImageContainer
                                }`}
                              >
                                <img
                                  src={category.featured_image}
                                  alt={category.name}
                                />
                              </div>
                            </Link>
                            <div className={classes.cardBody}>
                              <Link
                                to={`/category/${categorySlug}/${category.slug}`}
                                className={classes.link}
                              >
                                <div className={classes.cardTitle}>
                                  <h2>{category.name}</h2>
                                </div>
                              </Link>
                              <div className={classes.cardDescription}>
                                {excerpt(category.description)}
                              </div>
                              <div
                                className={grid && classes.cardButtonContainer}
                              >
                                <Link
                                  to={`/category/${categorySlug}/${category.slug}`}
                                  className={classes.link}
                                >
                                  <Button
                                    className={`${classes.cardButton} ${
                                      grid && classes.gridCardButton
                                    }`}
                                  >
                                    Details
                                  </Button>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </Col>
                      ))}
                  </Row>
                </Container>
              </div>
            )}
            <Footer />
          </>
        )}
      </div>
    </>
  )
}

export default Category
